import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-fiches-de-poste-item-detail',
  templateUrl: './fiches-de-poste-item-detail.component.html',
  styleUrls: ['./fiches-de-poste-item-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FichesDePosteItemDetailComponent implements OnInit {
  @Input() fiche: any;
  constructor() {}

  ngOnInit(): void {}
}
